import React, { FC }                    from "react";
import { useDispatch, useStore }        from "react-redux";
import { Form, Radio, Table }           from "semantic-ui-react";
import UpdateFacilityTargetType         from "../../../../application/usecase/facility/UpdateFacilityTargetType";
import Facilities                       from "../../../../domain/facility/Facilities";
import Facility                         from "../../../../domain/facility/Facility";
import FacilityWebReservationTargetType from "../../../../domain/facility/FacilityWebReservationTargetType";
import ReservationFacilityDelete        from "./ReservationFacilityDelete";
import ReservationFacilityEdit          from "./ReservationFacilityEdit";
import ReservationFacilityRegister      from "./ReservationFacilityRegister";

const ReservationFacilityList: FC = () => {
  const facilities: Facilities = useStore().getState().facilities;
  const updateFacilityTargetType: UpdateFacilityTargetType = new UpdateFacilityTargetType(useDispatch());

  return (
    <>
      <Form>
        <Form.Field>
          <label>予約対象施設・設備一覧</label>
          <ReservationFacilityRegister/>
        </Form.Field>
        <Form.Field>
          {
            facilities.isEmpty() ? <label>施設・設備が登録されていません。</label> :
              <Table striped={ true }>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>施設・設備名</Table.HeaderCell>
                    <Table.HeaderCell>WEB予約対象</Table.HeaderCell>
                    <Table.HeaderCell>操作</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    facilities.toList().map((facility: Facility) => (
                      <>
                        <Table.Row>
                          <Table.Cell>
                            { facility.name.value }
                          </Table.Cell>
                          <Table.Cell>
                            <Radio
                              toggle
                              label={ facility.targetType === FacilityWebReservationTargetType.AVAILABLE ? "WEB予約対象" : "WEB予約対象外" }
                              checked={ facility.targetType === FacilityWebReservationTargetType.AVAILABLE }
                              onClick={() => {
                                switch (facility.targetType) {
                                  default:
                                  case FacilityWebReservationTargetType.AVAILABLE:
                                    updateFacilityTargetType.execute(facility.id, FacilityWebReservationTargetType.NOT_AVAILABLE);
                                    break;
                                  case FacilityWebReservationTargetType.NOT_AVAILABLE:
                                    updateFacilityTargetType.execute(facility.id, FacilityWebReservationTargetType.AVAILABLE);
                                    break;
                                }
                              }}
                            />
                          </Table.Cell>
                          <Table.Cell>
                            <ReservationFacilityEdit facility={ facility }/>
                            <ReservationFacilityDelete facility={ facility }/>
                          </Table.Cell>
                        </Table.Row>
                      </>
                    ))
                  }
                </Table.Body>
              </Table>
          }
        </Form.Field>
      </Form>
    </>
  );
};

export default ReservationFacilityList;